<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col col-sm-10 col-md-8 col-lg-7 col-xl-6 col-xxl-6 col-xxxl-6">
        <div class="card border-0 rounded-0 bg-white authentication-card">
          <div class="card-body letter-spacing">
            <h4 class="fw-bold mb-0">{{ $t('feature.auth.forgot_password') }}?</h4>
            <p class="mb-0 fs-md-15 fs-lg-16 text-paragraph sub-text">
              {{ $t('feature.auth.$forgot_password.message') }}
            </p>
            <form v-on:submit="submit">
              <div class="form-group mb-15 mb-sm-20">
                <label class="d-block text-black fw-semibold mb-10">
                  {{ $t('form.email.label') }}
                </label>
                <input type="email" title="Email" class="form-control shadow-none text-black" v-model="username"
                  :class="[{ 'is-invalid': submitted && !usernameIsValid }]" :placeholder="$t('form.email.placeholder')"
                  required pattern="[^@\s]+@[^@\s]+\.[^@\s]+" />
              </div>
              <button
                class="default-btn transition fw-medium fs-md-15 fs-lg-16 d-block w-100"
                type="submit" v-on:click="setPristine" v-if="!loading">
                {{ $t('cta.submit') }}
              </button>
              <SpinnerLoading v-else/>
              <div class="text-center mt-15 mt-sm-20 mt-md-25">
                <router-link to="/login"
                  class="link-btn text-decoration-none fw-medium fs-md-15 fs-lg-16 position-relative">
                  <i class="ph-bold ph-arrow-left"></i>
                  {{ $t('cta.back_to_login') }}
                </router-link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- ERROR MESSAGE -->
    <div class="row justify-content-center">
      <div class="col col-sm-10 col-md-8 col-lg-7 col-xl-6 col-xxl-6 col-xxxl-6">
        <div class="alert alert-danger alert-dismissible fade border-0 border-danger-subtle border-top rounded-0 m-0"
          role="alert" id="errorMessage">
          <strong>{{ $t('error.something_went_wrong') }}</strong>
          <button type="button" class="btn-close" v-on:click="hideError" aria-label="Close"></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import API from '../../../services/api/api.service';
import { Alert } from "bootstrap";
import { ResetPasswordAuthFactor, ResetPasswordRequest } from '@/utils/models/user.model';
import SpinnerLoading from "@/components/Widgets/Spinner.vue";

export default defineComponent({
  name: "ForgotPassword",
  components: {
    SpinnerLoading
  },
  data: function() {
    return {
      loading: false,
      username: this.$route.query.identifier,
      submitted: false,
      errorMessage: undefined,
    } as {
      loading: boolean,
      username?: string,
      submitted: boolean,
      errorMessage?: Alert
    }
  },
  mounted() {
    this.errorMessage = new Alert('#errorMessage');
  },
  computed: {
    usernameIsValid(): boolean {
      var EMAIL_PATTERN = '^[^@\\s]+@[^@\\s]+\\.[^@\\s]+$';
      var EMAIL_REGEXP = new RegExp(EMAIL_PATTERN, 'i');
      return EMAIL_REGEXP.test(this.username ?? '');
    },
  },
  methods: {
    submit(e) {
      this.submitted = true;
      e?.preventDefault();
      this.sendRequest();
    },
    sendRequest() {
      this.loading = true;
      API.resetPasswordRequest({
        scope: ResetPasswordAuthFactor.email,
        identifier: this.username,
      } as ResetPasswordRequest).then((response) => {
        if(response.data.success === true) {
          const info = response.data.data;
          this.$router.push({path: '/reset-password', query: {identifier: info.identifier, expires_in: info.expires_in}});
        }
      }).catch((error) => {
        this.showError();
      }).finally(() => {
        this.loading = false;
      });
    },
    setPristine() {
      this.submitted = true;
    },
    showError() {
      const error = document.getElementById('errorMessage');
      error?.classList.add('show');
      setTimeout(() => {
        this.hideError();
      }, 5000)
    },
    hideError() {
      const error = document.getElementById('errorMessage');
      error?.classList.remove('show');
    }
  }
});
</script>